module.exports = __webpack_public_path__ + "media/chapter-ufo.98d639a2.mp4";